import { Component, Input } from '@angular/core';
import { ProductSearchPage, ProductSearchService, PageMetaService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-custom-category-summary',
  templateUrl: './custom-category-summary.component.html',
  standalone: false
})
export class CustomCategorySummaryComponent {
  @Input() breadcrumbs: any;

  constructor(
    protected pageMetaService: PageMetaService,
    protected productSearchService: ProductSearchService,
  ) {
    // empty
  }

  searchResults$: Observable<ProductSearchPage> = this.productSearchService
    .getResults()
    .pipe(filter((searchResult) => Object.keys(searchResult).length > 0));
}
